export default __webpack_public_path__ + "static/media/YAS0330.34I-29538_-17077_0.adf6180f.jpg";